
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.5 16.063V2.938A.935.935 0 0019.562 2H6.75C4.68 2 3 3.68 3 5.75v12.5C3 20.32 4.68 22 6.75 22h12.813c.519 0 .937-.418.937-.938v-.625a.945.945 0 00-.348-.73c-.164-.602-.164-2.316 0-2.918a.93.93 0 00.348-.727zM8 7.233C8 7.105 8.105 7 8.234 7h8.282c.129 0 .234.105.234.234v.782a.235.235 0 01-.234.234H8.234A.235.235 0 018 8.016v-.782zm0 2.5c0-.129.105-.234.234-.234h8.282c.129 0 .234.105.234.234v.782a.235.235 0 01-.234.234H8.234A.235.235 0 018 10.516v-.782zm9.898 9.766H6.75c-.691 0-1.25-.559-1.25-1.25 0-.688.563-1.25 1.25-1.25h11.148a14.066 14.066 0 000 2.5z","fill":"#282E3E"}})])
          )
        }
      }
    